var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmpty = function SvgEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.584 85.876H4.873a2.373 2.373 0 1 0 0 4.746h35.711a2.373 2.373 0 0 0 0-4.746Z",
    fill: "#CBD5E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.696 43.924h28.593a3.183 3.183 0 0 1 3.18 3.18V88.25H5.516V47.105a3.183 3.183 0 0 1 3.18-3.18Z",
    fill: "#F7FAFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.14 55.34H10.327v3.16h24.815v-3.16ZM35.14 63.724H10.327v3.16h24.815v-3.16ZM35.14 72.108H10.327v3.16h24.815v-3.16Z",
    fill: "#E2E8F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.683 96.195H45.61a2.652 2.652 0 1 0 0 5.304h51.074a2.652 2.652 0 1 0 0-5.304Z",
    fill: "#CBD5E0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.096 19h49.47v59.479H31.12a5.03 5.03 0 0 1-5.024-5.025V19Z",
    fill: "#EDF2F7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.406 54.402a5.076 5.076 0 0 0-5.075-5.074h-.01a5.076 5.076 0 0 0-5.074 5.074v19.314a5.076 5.076 0 0 1-5.065 4.763h15.224V54.402Z",
    fill: "#CBD5E0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.861 49.328H46.417v49.509h49.469V54.352a5.03 5.03 0 0 0-5.025-5.024Zm-44.445.01v5.074a5.076 5.076 0 0 0-5.074-5.074h5.074Z",
    fill: "#F7FAFC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.398 26.976h-7.976v2.99h7.976v-2.99ZM66.603 34.433H36.256v3.53h30.347v-3.53ZM66.603 40.056H36.256v3.53h30.347v-3.53Z",
    fill: "#CBD5E0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.337 57.882h-7.976v3.988h7.976v-3.988ZM86.326 65.897H55.98v3.53h30.347v-3.53ZM86.326 71.53H55.98v3.53h30.347v-3.53ZM86.326 77.163H55.98v3.53h30.347v-3.53ZM71.152 86.435H55.978v3.529h15.174v-3.53ZM104.105 30.255a1.945 1.945 0 0 0-3.509-1.675l-3.419 7.161a1.944 1.944 0 1 0 3.509 1.675l3.419-7.161ZM95.997 44.682a1.944 1.944 0 1 0 0-3.888 1.944 1.944 0 0 0 0 3.888ZM115.532 40.122a1.943 1.943 0 1 0-2.55-2.935l-6.306 5.48a1.944 1.944 0 1 0 2.55 2.935l6.306-5.48ZM102.805 50.554a1.944 1.944 0 1 0 0-3.888 1.944 1.944 0 0 0 0 3.888Z",
    fill: "#E2E8F0"
  })));
};
export { SvgEmpty as ReactComponent };